import * as React from 'react';

const ManageIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="manage-illustration"
    >
      <mask
        id="manage-mask0"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="5"
        width="28"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.3332 22.6667C29.3332 24.8758 27.5423 26.6667 25.3332 26.6667H6.6665C4.45736 26.6667 2.6665 24.8758 2.6665 22.6667V11.3334C2.6665 9.12424 4.45736 7.33337 6.6665 7.33337H17.2778L17.716 6.44739C18.0531 5.76519 18.7482 5.33337 19.5091 5.33337H25.3332C27.5423 5.33337 29.3332 7.12424 29.3332 9.33337V22.6667Z"
          fill="#778288"
        />
      </mask>
      <g mask="url(#manage-mask0)">
        <rect width="32" height="32" rx="2" fill="url(#manage-gradient0)" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9524 16.9414L18.1444 27.3534C18.4692 28.8959 19.83 30 21.4063 30H28.6646C29.5851 30 30.3313 29.2538 30.3313 28.3334C30.3313 27.9975 30.2298 27.6694 30.0401 27.3922L23.1793 17.3648C22.3094 16.0935 20.8683 15.3334 19.3279 15.3334H17.2572C16.5208 15.3334 15.9238 15.9303 15.9238 16.6667C15.9238 16.759 15.9334 16.8511 15.9524 16.9414Z"
        fill="#163984"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0002 4H4.00016C2.5274 4 1.3335 5.19391 1.3335 6.66667C1.3335 8.13943 2.5274 9.33333 4.00016 9.33333H12.0002C13.4729 9.33333 14.6668 8.13943 14.6668 6.66667C14.6668 5.19391 13.4729 4 12.0002 4ZM8.66683 11.3333H4.00016C2.5274 11.3333 1.3335 12.5272 1.3335 14C1.3335 15.4728 2.5274 16.6667 4.00016 16.6667H8.66683C10.1396 16.6667 11.3335 15.4728 11.3335 14C11.3335 12.5272 10.1396 11.3333 8.66683 11.3333Z"
        fill="#D3DFFB"
        style={{ mixBlendMode: 'multiply' }}
      />
      <defs>
        <linearGradient
          id="manage-gradient0"
          x1="16"
          y1="-6"
          x2="-6"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2969F2" />
          <stop offset="1" stopColor="#1ED4B2" />
        </linearGradient>
      </defs>
    </svg>
  );
});

ManageIllustration.displayName = 'ManageIllustration';

export { ManageIllustration };
